import { AgentCodeSnippet } from 'components/code';

const UPDATE_WOOP_CMD = 'castctl castware upgrade';

export const WoopAgentCommand = () => {
  return <AgentCodeSnippet code={UPDATE_WOOP_CMD} />;
};
